export default __webpack_public_path__ + "static/media/bb-00005.2ace0c5f.png";